/* global document:true */

import React from 'react'
import ReactDOM from 'react-dom'
import { Router, Route, Switch } from 'react-router-dom'
import { Provider } from 'react-redux'
import { history } from './helpers'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'

import Login from './pages/Login'
import Logs from './pages/Logs'

import 'antd/dist/antd.css'
import './styles/style.css'

import { store } from './core/store'
import i18next from 'i18next'

i18next
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lowerCaseLng: true,
    supportedLngs: ['en', 'fr'],
    lng: 'en',
    debug: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  })
  .then(() => {
    const scrollToTop = () => {
      const pusher = document.getElementById('app')
      if (pusher !== null) {
        pusher.scrollIntoView()
      }
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    history.listen(() => {})
    ReactDOM.render(
      <Provider store={store}>
        <Router history={history}>
          <Switch>
            <Route path="/" exact component={Logs} />
            <Route path="/login" exact component={Login} />
            <Route path="/invite/:id/:token" exact component={Login} />
            <Route path="/*" component={Logs} />
          </Switch>
        </Router>
      </Provider>,
      document.getElementById('root'),
    )
  })
